import * as yup from 'yup';

export const CreateServiceRequestSchema = yup.object({
    description: yup.string().required('Errors.required'),
});
